











import { Component, mixins } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import SyntaxHighlighter from '@/modules/shared/components/shared/utils/SyntaxHighlighter.vue'
import { Prop } from 'vue-property-decorator'
import { ChangelogCollectionPropertiesModel } from '@/modules/changelog/models/changelog-collection.model'

@Component({
  components: {
    Modal,
    SyntaxHighlighter
  }
})
export default class AdminChangelogInnerTableModal extends mixins<DialogMixin>(DialogMixin) {
  @Prop({ required: true }) changelog!: ChangelogCollectionPropertiesModel

  modalVisibility: boolean = false
}
